import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';

import featureFlags from './slices/feature-flags';
import layoutGrid from './slices/layout-grid';
import user from './slices/user';
import project from './slices/project';
import projects from './slices/projects';
import templates from './slices/templates';
import speakers from './slices/speakers';
import categories from './slices/categories';
import channels from './slices/channels';
import channel from './slices/channel';
import announcements from './slices/announcements';
import integrations from './slices/integrations';
import leaderboard from './slices/leaderboard';
import channelAdmins from './slices/channel-admins';
import superAdminNotifications from './slices/super-admin-notifications';
import access from './slices/access';
import passcodeLists from './slices/passcode-lists';
import registrants from './slices/registrants';
import audiences from './slices/audiences';
import channelSettings from './slices/channel-settings';
import stats from './slices/stats';
import series from './slices/series';
import content from './slices/content';
import stylepacks from './slices/stylepacks';

import saveProjectMiddleware from './slices/project/middleware/save-project-middleware';
import saveProjectByFieldsMiddleware from './slices/project/middleware/save-project-by-fields-middleware';
import saveSessionMiddleware from './slices/project/middleware/save-session-middleware';
import connectedAdmins from './slices/connected-admins';
import channelAnalytics from './slices/channel-analytics';

export const store = configureStore({
  reducer: {
    featureFlags: featureFlags,
    layoutGrid: layoutGrid,
    user,
    project,
    projects,
    templates,
    speakers,
    categories,
    channels,
    channel,
    announcements,
    integrations,
    leaderboard,
    connectedAdmins,
    channelAdmins,
    superAdminNotifications,
    access,
    passcodeLists,
    registrants,
    audiences,
    channelSettings,
    stats,
    series,
    channelAnalytics,
    content,
    stylepacks,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().prepend(
      saveProjectMiddleware.middleware,
      saveProjectByFieldsMiddleware.middleware,
      saveSessionMiddleware.middleware
    );
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
